module.exports = __webpack_public_path__ + "img/avatar6.4238e20f.png";